<div class="map-container">
    <div #map id="map" *ngIf="!errorMessage"></div>
    
    <div class="map-error" *ngIf="errorMessage">
        {{ errorMessage }}
    </div>
    
    <button 
        class="centerMe" 
        *ngIf="showCenterButton && !errorMessage"
        (click)="onCenterClick()"
        [title]="centerButtonTitle">
        <ion-icon name="locate"></ion-icon>
    </button>
</div>
